/*
 * @Author: keman.chen
 * @Date: 2023-08-25 11:35:51
 * @LastEditTime: 2024-01-04 14:37:47
 * @LastEditors: keman.chen
 * @Description: 
 * @FilePath: /tlog-dashboard/Users/keman.chen/code/monitor/packages/vue/src/index.ts
 */
import { getFlag, setFlag, slientConsoleScope, Severity } from '@tr-infra/pilot-utils'
import { EVENTTYPES } from '@tr-infra/pilot-shared'
import { VueInstance, ViewModel } from './types'
import { handleVueError } from './helper'

const hasConsole = typeof console !== 'undefined'

const PilotVue = {
  install(Vue: VueInstance): void {
    if (getFlag(EVENTTYPES.VUE) || !Vue || !Vue.config) return
    setFlag(EVENTTYPES.VUE, true)
    // vue 提供 warnHandler errorHandler报错信息
    Vue.config.errorHandler = function (err: Error, vm: ViewModel, info: string): void {
      handleVueError.apply(null, [err, vm, info, Severity.Error, Severity.Error, Vue])
      if (hasConsole && !Vue.config.silent) {
        slientConsoleScope(() => {
          console.error('Error in ' + info + ': "' + err.toString() + '"', vm)
          console.error(err)
        })
      }
    }
  }
}

export { PilotVue }
